import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Alert, Modal } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { client } from '@Utils'

export const ChangeCourseModal = ({
  ctxId,
  ctxCoursenum,
  show,
  toggle,
  currentState,
  dispatch,
}) => {
  const [errorText, updateErrorText] = useState(null)
  const [isValidMaster, updateIsValidMaster] = useState(false)
  const [targetCoursenum, updateTargetCoursenum] = useState('')
  const [missingBookNodes, setMissingBookNodes] = useState([])
  const [missingActs, setMissingActs] = useState([])

  const changeCourseHandler = async () => {
    if (!isValidMaster) {
      try {
        let resp = await client.post(
          '/account/admin_lti13.editContextCourse/',
          {
            currentCoursenum: ctxCoursenum,
            targetCoursenum: targetCoursenum,
            ctxId: ctxId,
          }
        )
        updateIsValidMaster(resp.data.hasSameMaster)
        setMissingActs(resp.data.missingActs)
        setMissingBookNodes(resp.data.missingBookNodes)
      } catch (err) {
        updateErrorText(err.response.data.error)
      }
    } else {
      try {
        await client.post('/account/admin_lti13.editContextCourse/', {
          currentCoursenum: ctxCoursenum,
          targetCoursenum: targetCoursenum,
          ctxId: ctxId,
          validated: isValidMaster,
        })
        ButterToast.raise({
          content: (
            <Cinnamon.Crisp
              title="Success"
              content="Successfully removed."
              scheme={Cinnamon.Crisp.SCHEME_BLUE}
              icon={<i className="far fa-thumbs-up fa-3x" />}
            />
          ),
        })
        // Trigger the lower components useEffect hook
        dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
        toggle(!show)
        updateErrorText(null)
      } catch (err) {
        if (err.response) {
          if (err.response.status === 500) {
            ButterToast.raise({
              content: (
                <Cinnamon.Crisp
                  title={err.response.statusText}
                  content={err.response.data.error}
                  scheme={Cinnamon.Crisp.SCHEME_RED}
                  icon={<i className="far fa-thumbs-down fa-3x" />}
                />
              ),
            })
          } else {
            updateErrorText(err.response.data.error)
          }
        } else {
          updateErrorText(err)
        }
      }
    }
  }

  const closeModalHandler = () => {
    toggle(!show)
    resetModalData()
  }

  const changeTargetCoursenum = targetCnum => {
    resetModalData()
    updateTargetCoursenum(targetCnum)
  }

  const resetModalData = () => {
    updateTargetCoursenum('')
    updateIsValidMaster(false)
    updateErrorText(null)
  }

  let errorAlert = errorText ? (
    <Alert className="alert-danger">{errorText}</Alert>
  ) : null

  return (
    <Modal show={show} onHide={closeModalHandler}>
      <Modal.Header closeButton>
        <Modal.Title>Change Context Course</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorAlert}
        <p>Validate and change context course?</p>
        <div>
          <label>
            Target Coursenum:
            <input
              className="ml-2"
              type="text"
              onChange={e => changeTargetCoursenum(e.target.value)}
              value={targetCoursenum}
            />
          </label>
        </div>
        <p>Same Master Course: {isValidMaster ? 'True' : 'False'}</p>
        {isValidMaster && (
          <div>
            {missingBookNodes.length > 0 ? (
              <React.Fragment>
                <h5>Missing Book Nodes:</h5>
                <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                  <ul>
                    {missingBookNodes.map((node, i) => (
                      <li key={i}>{node}</li>
                    ))}
                  </ul>
                </div>
              </React.Fragment>
            ) : (
              <p>No missing book nodes.</p>
            )}
            {missingActs.length > 0 ? (
              <React.Fragment>
                <h5>Missing Activities:</h5>
                <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                  <ul>
                    {missingActs.map((actTitle, i) => (
                      <li key={i}>{actTitle}</li>
                    ))}
                  </ul>
                </div>
              </React.Fragment>
            ) : (
              <p>No missing activities.</p>
            )}
          </div>
        )}
        <div className="text-center mt-4">
          {!isValidMaster ? (
            <div
              className="btn btn-myed btn-primary btn-primary-myed"
              onClick={changeCourseHandler}
            >
              Validate New Course
            </div>
          ) : (
            <div
              className="btn btn-success btn-myed btn-success-myed"
              onClick={changeCourseHandler}
            >
              Confirm Course Change
            </div>
          )}
          <div
            className="btn btn-myed btn-danger btn-danger-myed ml-3"
            onClick={() => toggle(false)}
          >
            Cancel
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

ChangeCourseModal.propTypes = {
  ctxId: PropTypes.string.isRequired,
  ctxCoursenum: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  currentState: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}
